import { gql } from 'graphql-request'

export const REMOVE_USER_READING = gql`
  mutation RemoveUserReading($id: Int!) {
    removeUserReading(id: $id) {
      id
    }
  }
`
